import React, { useState, useRef, useEffect, MutableRefObject } from 'react';

type FigureImageProps = {
    url: string;
}
const FigureImage:React.FC<FigureImageProps> = (props) => {

    const {url} = props;
    const [isVisible, setIsVisible] = useState(false);
    const imgRef = useRef(null);
  
    // 遅延読み込み処理
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // 一度読み込んだら監視を停止
          }
        },
        { threshold: 0.1 } // 少しでも表示されたら読み込み開始
      );
  
      if (imgRef.current) {
        observer.observe(imgRef.current);
      }
  
      return () => {
        if (imgRef.current) observer.unobserve(imgRef.current);
      };
    }, []);

    return (
        <figure className="c-result-item__detail__thumb"><img ref={imgRef} src={isVisible ? url : ""} alt="" width="1320" height="934" loading="lazy" /></figure>
    );
};
export default FigureImage;